import styled from 'styled-components';

export const StyledPanelSectionTitle = styled.div`
  font-family: ${props => props.theme.fonts.bold};
  font-size: 18px;
  color: #494949;
`;
